import Joi from 'joi';

import { stateData } from './Defaults';

export const stateSchema = Joi.object({
    deepomatic: Joi.array(),
    inspect: Joi.object({
        canPerformInstallation: Joi.boolean().default(false),
        pdlValidated: Joi.boolean().default(false),
    })
        .options({ stripUnknown: true })
        .default(stateData.inspect),
    wire: Joi.object({
        skipLteDbox: Joi.boolean().default(false),
    })
        .options({ stripUnknown: true })
        .default(stateData.wire),
    mesh: Joi.object({
        skipFwUpdate: Joi.boolean().default(false),
        skipBleValidation: Joi.boolean().default(false),
        meshCompleted: Joi.boolean().default(false),
    })
        .options({ stripUnknown: true })
        .default(stateData.mesh),
    test: Joi.object({
        skipTests: Joi.boolean().default(false),
        allTestsPassed: Joi.boolean().default(false),
        testsPassed: Joi.object().default({}),
    })
        .options({ stripUnknown: true })
        .default(stateData.test),
    signature: Joi.object({
        calibrationAck: Joi.boolean().default(false),
        businessAck: Joi.boolean().default(false),
    })
        .options({ stripUnknown: true })
        .default(stateData.signature),
    tabsEnabled: Joi.object({
        inspect: Joi.boolean().default(true),
        wire: Joi.boolean().default(false),
        mesh: Joi.boolean().default(false),
        test: Joi.boolean().default(false),
        doc: Joi.boolean().default(false),
    })
        .options({ stripUnknown: false })
        .default(stateData.tabsEnabled),
    document: Joi.object({
        everythingCleaned: Joi.boolean().default(false),
    })
        .options({ stripUnknown: true })
        .default(stateData.document),
    guideCustomer: Joi.object({
        downloadApp: Joi.boolean().default(false),
        loginToApp: Joi.boolean().default(false),
        setupHeatingSchedule: Joi.boolean().default(false),
        saveHeaterSetup: Joi.boolean().default(false),
        explainUserManualLocation: Joi.boolean().default(false),
    })
        .options({ stripUnknown: true })
        .default(stateData.guideCustomer),
})
    .options({ stripUnknown: true })
    .default(stateData);
